import {Component, inject, OnInit} from '@angular/core';
import {PageHeaderComponent} from '../../../shared/components/common/page-header/page-header.component';
import {AvatarUser} from '../../../shared/components/ui/avatar-user/avatar-user';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {CambiarContrasenha} from './cambiar-contrasenha/cambiar-contrasenha';
import {PerfilService} from './perfil.service';
import {UserPerfil} from './perfil.interface';
import {Spinner} from '../../../shared/components/ui/spinner/spinner';
import {ErrorService} from '../../../shared/services/error.service';

@Component({
  selector: 'app-perfil',
  imports: [
    PageHeaderComponent,
    AvatarUser,
    MatTabGroup,
    MatTab,
    MatTabContent,
    MatTabLabel,
    CambiarContrasenha,
    Spinner,
  ],
  templateUrl: './perfil.html',
  styleUrl: './perfil.scss'
})
export class Perfil implements OnInit {

  private perfilService = inject(PerfilService);
  private errorService = inject(ErrorService);

  user!: UserPerfil;
  loading = false;

  ngOnInit(): void {
    this.getPerfil();
  }

  getPerfil(): void {
    this.loading = true;
    this.perfilService.show().subscribe({
      next: (response) => {
        if (response.status) {
          this.user = response.data;
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }
}
